import React, { useState } from "react";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import DownloadIcon from "@mui/icons-material/Download";
import ShareIcon from "@mui/icons-material/Share"; // Import the Share icon
import "../styles.css"; // Import the CSS file
import CheckIcon from "@mui/icons-material/Check"; // Import the Check icon
import { Grid, Box } from "@mui/material";

function ButtonGroup({ texts }) {
  // The state variable that holds the texts array
  // const [texts, setTexts] = useState(texts);
  // A state variable that holds the copy status
  const [isCopied, setIsCopied] = useState(false);
  console.log("TEXTS IN BUTTONS", texts);
  // A function that converts the texts array into a string format

  const formatTexts = () => {
    // Sort the texts based on their distance to (0, 0)
    const sortedTexts = texts.sort((a, b) => {
      const distanceA = Math.sqrt(a.x * a.x + a.y * a.y);
      const distanceB = Math.sqrt(b.x * b.x + b.y * b.y);
      return distanceA - distanceB;
    });

    console.log("i am sortedTexts", sortedTexts);
    let result = "";
    sortedTexts?.forEach((item, index) => {
      result += `Paragraph: ${index + 1}\n`;
      result += `Keyword: ${item.keyword}\n`;
      result += `Text: ${item.paragraph}\n\n`;
    });
    return result;
  };

  // A function that handles the copy button click
  const handleCopy = async () => {
    // Set the copy status to true
    setIsCopied(true);
    // Get the formatted texts
    const text = formatTexts();
    try {
      // Write the text to the clipboard
      await navigator.clipboard.writeText(text);
      // Optionally, show some feedback to the user
    } catch (error) {
      // Handle any errors
      console.error(error);
    }
    // Reset the copy status to false after 1 second
    setTimeout(() => setIsCopied(false), 1000);
  };

  // A function that handles the download button click
  const handleDownload = () => {
    // Create a blob object from the formatted texts
    const blob = new Blob([formatTexts()], {
      type: "text/plain;charset=utf-8"
    });
    // Create a temporary URL for the blob
    const url = URL.createObjectURL(blob);
    // Create an anchor element with the download attribute
    const link = document.createElement("a");
    link.href = url;
    link.download = "texts.txt";
    // Append the link to the document body and click it
    document.body.appendChild(link);
    link.click();
    // Remove the link from the document and revoke the URL
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // A function that handles the share button click
  const handleShare = () => {
    // Get the formatted texts
    const text = formatTexts();
    // Encode the text and the subject for the email
    const encodedText = encodeURIComponent(text);
    const encodedSubject = encodeURIComponent("Mosaic Writer");
    // Create a mailto link with the encoded text and subject
    const mailtoLink = `mailto:?body=${encodedText}&subject=${encodedSubject}`;
    // Open the mailto link in a new window
    window.open(mailtoLink, "_blank");
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={1}>
        <Grid item xs={8}></Grid>
        <Grid item xs={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="button-group" style={{ marginLeft: "auto" }}>
            {/* The copy button */}
            <button className="button" onClick={handleCopy}>
              {/* Show either the Check icon or the FileCopy icon based on the copy status */}
              {isCopied ? <CheckIcon /> : <FileCopyIcon />}
            </button>
            {/* The download button */}
            <button className="button" onClick={handleDownload}>
              <DownloadIcon />
            </button>
            {/* The share button */}
            <button className="button" onClick={handleShare}>
              <ShareIcon />
            </button>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ButtonGroup;
